import { useMemo } from "react";

import { useTypedSelector } from "../store/store";
import routes from "../utils/constants/router";
import { IRouteElement, ISideMenuRoute } from "../utils/constants/routes";

function useCurrentRoutes() {
  const session = useTypedSelector((state) => state.session);
  const { brand } = useTypedSelector((state) => state.environment);

  const navigationRoutes: {
    routes: IRouteElement;
    sideMenu: ISideMenuRoute;
  } = useMemo(() => {
    const isPrivate = !!session.isInitialized && !!session.sessionKey;

    const publicSideMenuByBrand = routes.publicSideMenu();
    const privateSideMenuByBrand = routes.privateSideMenu();

    const publicSideMenu = publicSideMenuByBrand[brand];
    const privateSideMenu = privateSideMenuByBrand[brand];

    if (isPrivate) {
      return { routes: routes.private, sideMenu: privateSideMenu };
    }

    return { routes: routes.public, sideMenu: publicSideMenu };
  }, [session.isInitialized, session.sessionKey, brand]);

  return navigationRoutes;
}

export default useCurrentRoutes;
